export default __webpack_public_path__ + "static/media/Mask Group 29@2x.86a51f37.png";